import { MessageSquareWarning } from 'lucide-react';

import { SidebarItem } from './SidebarItem';
import { SidebarSection } from './SidebarSection';

export function ObservabilitySidebar() {
  return (
    <SidebarSection title="Observability">
      <SidebarItem
        label="Alerting"
        to="portainer.alerting"
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-alerting"
      />
    </SidebarSection>
  );
}
